import { Autoplay, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import React from 'react'

// More options are available for swiper from https://swiperjs.com/swiper-api#custom-build

export interface CarouselProps {
    carouselProps?: CarouselElementsProps
    children?: React.ReactNode
}

export interface CarouselElementsProps {
    carouselConfig?: CarouselConfig
    swiperConfig?: Swiper
}

export interface CarouselConfig { }

export const Carousel = React.forwardRef((props: CarouselProps, ref: any) => {
    const { children, carouselProps } = props

    const carouselConfig = carouselProps && carouselProps.carouselConfig ? carouselProps.carouselConfig : undefined
    const swiperConfig = carouselProps && carouselProps.swiperConfig ? carouselProps.swiperConfig : undefined

    // The ref can be used to access the Swiper instance methods and properties. For example: myRef.current.swiper.slideNext()

    return (
        <Swiper
            {...swiperConfig}
            modules={[Autoplay]}
            /*@ts-ignore*/ // A necessary hack to open up Swiper instance functionality in React
            ref={ref}
        >
            {Slides(children)}
        </Swiper>
    )
})

const Slides = children => {
    return React.Children.map(children, (child, key) =>
        React.createElement(SwiperSlide, null, React.cloneElement(child, { className: 'swiper-slide-child', key }))
    )
}

export default Carousel
